import { atom } from 'jotai'
import orderBy from 'lodash/orderBy'
import * as api from '../../../services/api'
import { getAllScripts } from '../../../services/api/script'

export const projects = atom([])
export const sharedProjects = atom([])
export const scriptsByProject = atom({})
export const projectsIsLoading = atom(false)
export const sharedProjectsLoading = atom(false)
export const scriptIsLoading = atom(false)
export const loadingScripts = atom(true)
export const projectsLoadingError = atom(false)
export const selectedProject = atom(false)
export const activeProject = atom(false)
export const activeProjectScripts = atom([])
export const allScripts = atom([])
export const defaultScriptUuid = atom(null)
export const setDefaultScriptUuid = atom(
  (get) => get(defaultScriptUuid),
  (get, set, uuid) => set(defaultScriptUuid, uuid)
)

export const getScripts = atom(
  (get) => ({ scripts: get(allScripts) }),
  (get) => ({ scripts: get(allScripts) })
)

export const loadSharedProjects = atom(
  (get) => ({ loading: get(sharedProjectsLoading) }),
  async (get, set) => {
    const isLoading = get(sharedProjectsLoading)
    if (isLoading) return
    set(sharedProjectsLoading, true)
    try {
      const projectsList = await api.sharedProjects.getProjects()
      set(sharedProjects, projectsList)
    } catch (error) {
      set(projectsLoadingError, error)
    }
    set(sharedProjectsLoading, false)
  }
)

export const loadProjects = atom(
  (get) => ({ loading: get(projectsIsLoading) }),
  async (get, set) => {
    const isLoading = get(projectsIsLoading)
    if (isLoading) return
    set(projectsIsLoading, true)
    try {
      const projectsList = await api.project.getProjects()
      set(projects, projectsList)
    } catch (error) {
      set(projectsLoadingError, error)
    }
    set(projectsIsLoading, false)
  }
)

export const loadScripts = atom(
  (get) => ({ loading: get(scriptIsLoading) }),
  async (get, set) => {
    const isLoading = get(scriptIsLoading)
    if (isLoading) return
    set(scriptIsLoading, true)
    set(loadingScripts, true)
    try {
      const scripts = await getAllScripts()
      const filtered = orderBy(scripts, ['updated_at'], ['desc'])
      set(allScripts, filtered)
      try {
        const preferred = filtered.find((s) => s?.data?.default)
        set(defaultScriptUuid, preferred?.uuid)
      } catch (e) {
        // ignore
      }
    } catch (error) {
      console.warn('failed load scripts', error)
    }
    set(scriptIsLoading, false)
    set(loadingScripts, false)
  }
)

export const setProjectScripts = atom(
  () => ({}),
  async (get, set, { project }) => {
    if (!project) return
    try {
      const allScriptsProject = get(scriptsByProject)
      const scripts = allScriptsProject[project.uuid]
      if (!scripts) {
        try {
          const projectScripts = await api.project.getProjectScripts(project.uuid)
          set(scriptsByProject, { ...allScriptsProject, [project.uuid]: projectScripts })
        } catch (error) {
          console.warn('cant fetch scripts', error)
        }
      }
    } catch (error) {
      set(projectsLoadingError, error)
    }
  }
)
